<template>
  <div v-wechat-title="extraItem.extras('customtitle.model') || title">
    <Header :extras="extras" platform="wap"></Header>
    <div class="question-main-wap" v-if="!errorMessage">
      <div
        class="question-title-wap"
        :style="{
          display:
            extraItem.extras('titlefont.display') == 1 ? 'block' : 'none',
          color: extraItem.extras('titlefont.color'),
          fontSize: isPreview ? '' : pxOrVw(extraItem.extras('titlefont.size')),
          fontWeight:
            extraItem.extras('titlefont.weight') == 'default'
              ? '500'
              : extraItem.extras('titlefont.weight'),
        }"
      >
        {{ extraItem.extras("customtitle.model") || title }}
      </div>
      <wap-fields
        :form="questionnaireList"
        :extras="extras"
        :rulesJump.sync="rulesJump"
        ref="questionChild"
      />
      <div
        class="question-footer-wap"
        v-if="isShowBtn"
        @click="submit()"
        :style="{
          cursor: isPreview ? 'not-allowed' : 'pointer',
          backgroundColor:
            extraItem.extras('themecolor.bgcolor') === '#1665D8' &&
            extraItem.extras('submitfont.bgcolor')
              ? extraItem.extras('submitfont.bgcolor')
              : extraItem.extras('themecolor.bgcolor'),
          color: extraItem.extras('submitfont.color'),
        }"
      >
        <span v-if="extraItem.extras('submitfont.model')">{{
          extras | extra("submitfont.model")
        }}</span>
        <span v-if="!extraItem.extras('submitfont.model')">提交</span>
      </div>
    </div>

    <div class="m-currency-content" v-if="errorMessage">
      <form-status
        :status="
          questionaryStatus == 0
            ? 'nostart'
            : questionaryStatus == 2
            ? 'over'
            : 'error'
        "
        :test="errorMessage"
        platform="wap"
      ></form-status>
    </div>

    <CountDown
      ref="count-down"
      :extras="extras"
      platform="wap"
      :totalTimeM="
        questionnaireInfo.isTimeLimit == '2' ? questionnaireInfo.limitTime : 0
      "
      :costTime="costTime"
      @calibration="questionnaireTimeGet"
      @autoSubmit="submit"
    ></CountDown>
  </div>
</template>

<script>
import questionaryMixin from "../../../mixins/questionary";
import templateMixin from "../../../mixins/exam-config";
import WapFields from "@/components/WapFields.vue";
export default {
  name: "examWapQuestionnaire",
  components: {
    WapFields,
  },
  mixins: [templateMixin, questionaryMixin],
};
</script>

<style scoped></style>
